export default class FilterWindow {
	constructor(root) {
		this.root = root;
		this.filtersCloseBtn = this.root?.querySelector('.filter-window-close');
		this.filtersShowResultsBtn = this.root?.querySelector('.filter-window-show-results');

		this.filtersCloseBtn?.addEventListener('click', () => this.closeFilters());
		this.filtersShowResultsBtn?.addEventListener('click', () => this.closeFilters());
	}

	openFilters() {
		this.root?.classList.add('active');
	}

	closeFilters() {
		this.root?.classList.remove('active');
	}
}
